import React, { useMemo } from 'react'
import { PushlyAi, Well } from '@pushly/aqe/lib/components'
import { INotificationBuilderState } from '../interfaces/notification-builder-state.interface'

type WellLoadingConfig = Exclude<Well['props']['loading'], boolean | undefined>

export const useNotificationContentLoadingView = ({
    pushlyAi,
    pageAnalyzer,
    stzAvailabilityValidating,
}: INotificationBuilderState): WellLoadingConfig => {
    const isGeneratingAi = pushlyAi.isGenerating
    const isAnalyzingLandingUrl = pageAnalyzer.isAnalyzing
    const isStzAvailabilityValidating = stzAvailabilityValidating

    const enabled = isGeneratingAi || isAnalyzingLandingUrl || isStzAvailabilityValidating

    const icon = useMemo(
        () => (
            <PushlyAi
                animate={true}
                style={{
                    color: 'rgb(0, 119, 160)',
                    fontSize: 32,
                }}
            />
        ),
        [],
    )

    const style = useMemo(
        () => ({
            zIndex: 20,
            paddingTop: 60,
            backgroundColor: 'rgba(255, 255, 255, 0.90)',
            backdropFilter: 'blur(.72px)',
        }),
        [],
    )

    let message: string | null = null
    if (isGeneratingAi) message = 'Generating Notification Content'
    else if (isAnalyzingLandingUrl) message = 'Analyzing Landing URL'
    else if (isStzAvailabilityValidating) message = 'Validating Selected Timezone Delivery'

    return useMemo(
        () =>
            !enabled
                ? { enabled: false }
                : {
                      enabled: true,
                      icon,
                      style,
                      message: (
                          <span
                              style={{
                                  fontSize: 14,
                                  lineHeight: '40px',
                              }}
                          >
                              {!!message ? `${message} ...` : null}
                          </span>
                      ),
                  },
        [isGeneratingAi, isAnalyzingLandingUrl, isStzAvailabilityValidating],
    )
}
